<template>
  <main class="bg-white pt-24 pb-20 px-4">
    <div class="max-w-3xl mx-auto">
      <h1 class="text-4xl font-bold tracking-tight mb-8" style="color: var(--color-krate-dark-900);">Status</h1>

      <div class="rounded-lg border-2 p-6 mb-6" style="border-color: #10b981; background-color: #ecfdf5;">
        <div class="flex items-center gap-3">
          <span class="text-2xl" style="color: #10b981;">✔</span>
          <p class="font-semibold text-lg" style="color: #065f46;">All systems operational</p>
        </div>
      </div>

      <h2 class="text-xl font-semibold mt-12 mb-4" style="color: var(--color-krate-dark-900);">Components</h2>
      <ul class="space-y-3">
        <li class="flex items-center justify-between py-3 border-b" style="border-color: var(--color-krate-dark-200);">
          <span style="color: var(--color-krate-dark-700);">Website (krate.sh)</span>
          <span style="color: #10b981;">✔ Operational</span>
        </li>
        <li class="flex items-center justify-between py-3 border-b" style="border-color: var(--color-krate-dark-200);">
          <span style="color: var(--color-krate-dark-700);">Portal (app.krate.sh)</span>
          <span style="color: #10b981;">✔ Operational</span>
        </li>
        <li class="flex items-center justify-between py-3 border-b" style="border-color: var(--color-krate-dark-200);">
          <span style="color: var(--color-krate-dark-700);">API (api.krate.sh)</span>
          <span style="color: #10b981;">✔ Operational</span>
        </li>
        <li class="flex items-center justify-between py-3 border-b" style="border-color: var(--color-krate-dark-200);">
          <span style="color: var(--color-krate-dark-700);">Container registry</span>
          <span style="color: #10b981;">✔ Operational</span>
        </li>
      </ul>

    </div>
  </main>
</template>
